// Tabs — simple horizontal tab strip used by settings + reports pages.
//
// Wave E shared component. The legacy ReportsPage rolled its own; we keep
// that working but new pages adopt this primitive for consistency.

import { cn } from '../../../utils/cn';
import styles from './Tabs.module.css';

export interface TabItem {
  id: string;
  label: string;
  count?: number;
}

export interface TabsProps {
  items: TabItem[];
  value: string;
  onChange: (id: string) => void;
  className?: string;
  ariaLabel?: string;
}

export function Tabs({
  items,
  value,
  onChange,
  className,
  ariaLabel = 'Tabs',
}: TabsProps): JSX.Element {
  return (
    <div role="tablist" aria-label={ariaLabel} className={cn(styles.tabs, className)}>
      {items.map((item) => {
        const active = item.id === value;
        return (
          <button
            key={item.id}
            type="button"
            role="tab"
            aria-selected={active}
            className={cn(styles.tab, active && styles.active)}
            onClick={() => onChange(item.id)}
          >
            <span>{item.label}</span>
            {item.count !== undefined ? (
              <span className={styles.count}>{item.count}</span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
